import { makeStyles } from "@mui/styles";

export const useWeekDayCheckBoxStyles = makeStyles({
    container: {
        display: "flex",
        gap: "8px",
    },
    item: {
        flexGrow: 1,
    },
});
